import React from 'react';

const FeaturedIn = () => {
  return (
    <section className="py-20 bg-black border-t border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Eyebrow */}
          <span className="text-teal-400 text-xs uppercase tracking-widest font-semibold mb-8 block">
            Destacado en
          </span>

          {/* Logos */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 mb-12 opacity-40 grayscale hover:opacity-60 transition-opacity duration-300">
            {/* TechCrunch */}
            <div className="text-white text-2xl md:text-3xl font-bold tracking-tight">
              TechCrunch
            </div>
            
            {/* Forbes */}
            <div className="text-white text-2xl md:text-3xl font-bold tracking-tight">
              FORBES
            </div>
            
            {/* Bloomberg */}
            <div className="text-white text-2xl md:text-3xl font-bold tracking-tight">
              Bloomberg
            </div>
          </div>

          {/* Quote */}
          <blockquote className="text-xl md:text-2xl text-gray-400 italic max-w-3xl mx-auto">
            "Urpe está construyendo una nueva generación de emprendedores libres."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default FeaturedIn;
